import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-6 px-4 relative" data-id="element-72">
      <div className="text-center relative z-10" data-id="element-73">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-3xl sm:text-4xl md:text-5xl font-black text-swiss-charcoal leading-tight mb-3" data-id="element-74">
          Ihr komplettes W&R Jahr. Fertig. Jetzt.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-base sm:text-lg text-gray-600 mb-4 leading-snug max-w-lg mx-auto" data-id="element-75">
          6 vollständige Module + 4 professionelle Toolkits. Strukturiert nach
          Lehrplan 21. Entwickelt für Schweizer Lehrpersonen der Sekundarstufe
          II.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.15
      }} className="mb-4" data-id="element-76">
          <a href="#pricing" className="block cursor-pointer hover:opacity-95 transition-opacity" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/ebgrHHkCT6niQbwSbxkEbc/my-project-page-1_(6).png" alt="W&R Master-System 2026" className="w-full h-auto object-contain drop-shadow-xl" data-id="element-78" />
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex flex-col items-center justify-center gap-1.5 mb-5" data-id="element-79">
          <div className="flex items-center gap-1 text-swiss-gold" data-id="element-80">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-81" />)}
          </div>
          <span className="text-sm font-bold text-swiss-charcoal" data-id="element-82">
            +500 Lehrpersonen | 100% Lehrplan 21 | 🇨🇭 Schweiz
          </span>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.25
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3 text-sm font-medium text-gray-700 mb-5 text-left max-w-md mx-auto" data-id="element-83">
          <div className="flex items-center gap-2" data-id="element-84">
            <CheckCircle2Icon className="w-5 h-5 text-swiss-green-cta shrink-0" data-id="element-85" />
            <span data-id="element-86">100% Lehrplan 21 Konform</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-87">
            <CheckCircle2Icon className="w-5 h-5 text-swiss-green-cta shrink-0" data-id="element-88" />
            <span data-id="element-89">Schweizer Rechtsprechung 2026</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-90">
            <CheckCircle2Icon className="w-5 h-5 text-swiss-green-cta shrink-0" data-id="element-91" />
            <span data-id="element-92">Sofort-Download (PDF)</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-93">
            <CheckCircle2Icon className="w-5 h-5 text-swiss-green-cta shrink-0" data-id="element-94" />
            <span data-id="element-95">Einmalige Zahlung</span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-96">
          <CTAButton className="w-full sm:w-auto sm:min-w-[300px]" data-id="element-97">
            JETZT ENTDECKEN
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}